define('modules/success/success_view',['backbone', 'jquery', '_', 'text!./success_template.html'], function (
  Backbone,
  $,
  _,
  template
) {
  'use strict';
  var View = Backbone.View.extend({
    initialize: function (opts) {
      _.extend(this, opts);
    },

    hasSidebar: false,
    subViews: [],

    template: _.template(template),

    events: {
      'click .js-success-ok': 'closeModal',
    },

    closeModal: function () {
      this.trigger('close');
    },

    render: function () {
      this.$el.html(this.template({ message: this.message }));
      return this;
    },

    remove: function () {
      _.each(this.subViews, function (view) {
        if (view && view.remove) {
          view.remove();
        }
      });
      this.$el.off();
      this.$el.empty();
      this.stopListening();
      return this;
    },
  });
  return View;
});

